/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 新建/编辑页
 */
'use strict';
angular.module("editImageModule", ['editImageRouterModule']).
    controller('editImageCtrl', ['$scope', '$timeout', '$validation', '$stateParams', '$state', 'localStorageService', 'modalDialog', '$q', 'ueditorService', 'httpService', "$element", "$compile","persinalLibraryService","editPictureService", function ($scope, $timeout, $validation, $stateParams, $state, localStorageService, modalDialog, $q, ueditorService, httpService, $element, $compile, persinalLibraryService,editPictureService) {
        initStatus();
        initData();
        /**
         * [save description] 保存
         * @return {[type]} [description]
         */

        $scope.save = function () {
            $scope.list.bPub = false;
            saveContent().then(function () {
                return validator();
            }).then(function () {
                return save();
            }).then(function (data) {
                if (data.success) {
                    var newId = data.data.id;
                    $scope.list.id = newId;
                    // modalDialog.alertType("", "保存稿件成功", "success", false);
                    modalDialog.success("保存稿件成功", "success", false, function () { }, function () { }, '', 'left0');
                    reFreshListPage();
                    ueditorService.saveToLocal(newId);
                    $state.go("editImage", { id: newId, type: 8 });
                }
            });
        };
        /**
         * [submission description] 投稿
         * @return {[type]} [description]
         */
        $scope.submission = function () {
            $scope.list.bPub = false;
            saveContent().then(function () {
                return validator();
            }).then(function () {
                return save();
            }).then(function (data) {
                if (data.success) {
                    var newId = data.data.id;
                    $scope.list.id = newId;
                    var vparams = {
                        ids: newId
                    };
                    $scope.loadingPromise = httpService.http('/mcnww/web/article/contribute.do', vparams, 'get').then(function (data) {
                        modalDialog.success('投稿成功', 'success', false, function () {
                            reFreshListPage();
                            ueditorService.saveToLocal(newId);
                            window.close();
                        }, function () {}, 2000, 'left0');
                    }, function() {
                        $state.go("editImage", {
                            id: newId,
                            type: 5
                        }, {
                            reload: 'editImage'
                        });
                    });
                }
            });
        };
        /**
         * [save description] 保存方法
         * @return {[type]} [description]
         */
        function save() {
            var deffer = $q.defer();
            $scope.list.articleWordsCount = $scope.list.DOCWORDSCOUNT;
            $scope.list.pictureIds = $scope.data.DOC_PICTURELIST.reduce((res, item)=>{
                return res + item.originUrl.split('/').slice(-1)[0] +":" + encodeURIComponent(item.fileName) + ':' + item.originUrl + ':undefined:' + item.picDesc + ',';
            },'')
            $scope.loadingPromise = httpService.http("/mcnww/web/article/addEdit.do", {...$scope.list}, "post").then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        /**
         * [validator description] 表单校验
         * @return {[type]} [description]
         */
        function validator() {
            var deffer = $q.defer();
            $validation.validate($scope.editImageForm).success(function () {
                deffer.resolve();
            }).error(function (result) {
                angular.invalidPosition($scope.editImageForm, $element);
            });
            return deffer.promise;
        }
        /**
         * [saveContent description] 保存正文
         * @return {[type]} [description]
         */
        function saveContent() {
            var deffer = $q.defer();
            ueditorService.saveContent($scope.list);
            deffer.resolve();
            return deffer.promise;
        }
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                inputData: '',
                uploaderImgSelected: []
            };
            $scope.data = {
                DOC_PICTURELIST: [],
            }
            $scope.list = {
                id: 0,
                articleTitle: "",
                articleContent: "",
                articleHtmlCon: "",
                articleType: 3,
                firstClassId: "",
                secondClassId: "",
                articleStatus: "",
                remark: '',
            };
        }
        /**
         * [initList description] 初始化表单数据
         * @return {[type]} [description]
         */
        function initList() {
            var deffer = $q.defer();
            if (!!$stateParams.id) {
                getDraftInfo().then(function (result) {
                    for (var i in $scope.list) {
                        $scope.list[i] = result.data[i];
                    }
                    $scope.data.DOC_PICTURELIST = result.picUrlList;
                    deffer.resolve();
                });
            } else {
                deffer.resolve();
            }
            return deffer.promise;
        }
        /**
         * [getDraftInfo description] 查询稿件信息
         * @return {[type]} [description]
         */
        function getDraftInfo() {
            var deffer = $q.defer();
            var params = {
                id: $stateParams.id
            };
            $scope.loadingPromise = httpService.http("/mcnww/web/article/findById.do", params, "get").then(function (result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getClassicListOneLevel().then(function () {
                return getClassicListTwoLevel();
            }).then(function () {
                return initList();
            }).then(function (data) {
                loadUeditor(data);
                reSelectClassify();
            });

        }
        /**
         * [reSelectClassify description] 选中分类
         * @return {[type]} [description]
         */
        function reSelectClassify() {
            var flag = true;
            for (var i = 0; i < $scope.status.classicListOneLevel.length; i++) {
                if ($scope.status.classicListOneLevel[i].id == $scope.list.firstClassId) {
                    flag = false;
                    $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[i]);
                    break;
                }
            }
            if (flag) {
                $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[0]);
            }
            flag = true;
            getClassicListTwoLevel().then(function () {
                for (var j = 0; j < $scope.status.classicListTwoLevel.length; j++) {
                    if ($scope.status.classicListTwoLevel[j].id == $scope.list.secondClassId) {
                        flag = false;
                        $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[j]);
                        break;
                    }
                }
                if (flag) {
                    $scope.status.selectedTwoLevel = $scope.status.classicListTwoLeve === undefined ? $scope.status.selectedTwoLevel : $scope.status.classicListOneLevel.unshift({ name: "请选择" });
                    $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListOneLevel[0]);
                }
            });
        }
        /**
         * [getClassicList description] 获取一级分类
         * @return {[type]} [description]
         */
        function getClassicListOneLevel() {
            var deffer = $q.defer();
            httpService.http("/mcnww/web/classic/classicList.do", "", "get").then(function (data) {
                $scope.status.classicListOneLevel = (function (data) {
                    for (var i in data.data) {
                        data.data[i].name = data.data[i].departName;
                    }
                    return data.data;
                })(data);
                $scope.status.classicListOneLevel.unshift({ name: "请选择" });
                $scope.status.selectedOneLevel = $scope.status.classicListOneLevel[0];
                // $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                deffer.resolve();
            });
            return deffer.promise;
        }
        $scope.getClassicListTwoLevel = getClassicListTwoLevel;
        /**
         * [getClassicListTwoLevel description] 获取二级分类
         * @return {[type]} [description]
         */
        function getClassicListTwoLevel() {
            var deffer = $q.defer();
            if (!$scope.status.selectedOneLevel) {
                deffer.resolve();
                return deffer.promise;
            }
            var params = {
                id: $scope.status.selectedOneLevel.id,
            };
            httpService.http("/mcnww/web/classic/classicList.do", params, "get").then(function (data) {
                $scope.status.classicListTwoLevel = (function (data) {
                    for (var i in data.sList) {
                        data.sList[i].name = data.sList[i].departName;
                    }
                    return data.sList;
                })(data);
                $scope.status.classicListTwoLevel.unshift({ name: "请选择" });
                $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[0]);
                $scope.list.secondClassId = angular.isDefined($scope.list.secondClassId) ? $scope.list.secondClassId : undefined;
                $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getTwoLevelid 获取二级分类id]
         * @return {[type]} [description]
         */
        $scope.getTwoLevelid = function () {
            $scope.list.secondClassId = $scope.status.selectedTwoLevel.id;
        };
        /**
         * [loadUeditor description] 加载编辑器
         * @return {[type]} [description]
         */
        function loadUeditor(data) {
            var $ueditor = $("<ueditor></ueditor>");
            var $ueditorLocation = $element.find("ueditorLocation");
            LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function () {
                $ueditor.attr({
                    type: 'image',
                    list: "list",
                    "has-content": "status.hasContent",
                    versionid: $scope.list.id,
                    placeholder: "请输入文章正文",
                    infullscreen: "status.infullscreen"
                });
                $ueditor = $compile($ueditor)($scope);
                $ueditorLocation.append($ueditor);
                var ue = UE.getEditor('ueditor');
                // ue.ready(function(){
                //     ueditorService.drawVideoMark(true, true);
                // });
            });

        }
        /**
         * [reFreshList description] 刷新列表页
         * @return {[type]} [description]
         */
        function reFreshListPage() {
            localStorageService.set("refresh", Math.random());
        }
        /**
         * [insertImg description] 插入图片或改变图片属性
         * @return {[type]}         [description]
         */
        $scope.multiImgsUploader = function (limit, index) {
            ueditorService.basicUploadPic(undefined, {limit}).then(function(data) {
                var dom = document.createElement("div");
                dom.innerHTML = data;
                var $imgs = dom.querySelectorAll("img");
                if (index === undefined) {
                    var picList = [];
                    for (var l = 0; l < $imgs.length; l++) {
                        picList.push({
                            originUrl: new URL($imgs[l].src).pathname || '',
                            fileName: $imgs[l].title || '',
                            picDesc: '',
                        });
                    }
                    $scope.data.DOC_PICTURELIST = $scope.data.DOC_PICTURELIST.concat(picList);
                } else {
                    $scope.data.DOC_PICTURELIST.splice(index, 1, {
                        originUrl: new URL($imgs[0].src).pathname || '',
                        fileName: $imgs[0].title || '',
                        picDesc: $scope.data.DOC_PICTURELIST[index].picDesc
                    })
                }
                
            });
        };
        function swapItems(list, index1, index2) {
            list[index1] = list.splice(index2, 1, list[index1])[0];
        }
        // 图片上移开始
        $scope.upMove = function (index) {
            if (index !== 0) {
                swapItems($scope.data.DOC_PICTURELIST, index, index - 1);
            }
        };

        // 图片下移开始
        $scope.downMove = function (index) {
            if (index !== $scope.data.DOC_PICTURELIST.length - 1) {
                swapItems($scope.data.DOC_PICTURELIST, index, index + 1);
            }
        };
        // 选择批量上传后的图片结束
        // 单个删除批量上传后的图片
        $scope.deleteImg = function (ID) {
            modalDialog.confirmModal('删除', '确定删除？', function () {
                var temp = [];
                for (var i = 0; i < $scope.data.DOC_PICTURELIST.length; i++) {
                    if (i != ID) {
                        temp.push($scope.data.DOC_PICTURELIST[i]);
                    }
                }
                $scope.data.DOC_PICTURELIST = temp;
                // $scope.data.DOC_PICTURELIST.splice(ID, 1);
            });
        };
        $scope.moveUploadImg = function (index) {
            $scope.data.DOC_PICTURELIST.splice(index, 1);
        };
        // 选择批量上传后的图片
        $scope.selectImg = function (item) {
            if ($scope.status.uploaderImgSelected.indexOf(item) < 0) {
                $scope.status.uploaderImgSelected.push(item);
            } else {
                $scope.status.uploaderImgSelected.splice($scope.status.uploaderImgSelected.indexOf(item), 1);
            }
        };
        // 全选批量上传后的图片
        $scope.selectAllImg = function () {
            $scope.status.uploaderImgSelected =
                $scope.status.uploaderImgSelected.length === $scope.data.DOC_PICTURELIST.length ? [] : [].concat($scope.data.DOC_PICTURELIST);
        };
        // 批量删除上传后的图片
        $scope.batchDelete = function () {
            modalDialog.confirmModal('删除', '是否确认删除选择的图片', function () {
                var temp = [];
                angular.forEach($scope.data.DOC_PICTURELIST, function (data, index, array) {
                    if ($scope.status.uploaderImgSelected.indexOf(data) < 0) {
                        temp.push(data);
                    }
                });
                $scope.data.DOC_PICTURELIST = temp;
                $scope.status.uploaderImgSelected = [];
            });
        };
        function downloadOrgImgList(imgArray, attribute, imgname) {
            var deffer = $q.defer();
            angular.forEach(imgArray, function (data, index, array) {
                var fileArray = data.fileName.split('.');
                var type = fileArray[fileArray.length - 1];
                var a = document.createElement('a');
                a.setAttribute('href', data.originUrl);
                a.setAttribute('download', data[imgname] + '.' + type);
                a.click();
            });
            $timeout(function () {
                // 假蒙层
                deffer.resolve();
            }, 2000);
            return deffer.promise;
        }
        $scope.multiImgsDownload = function () {
            $scope.loadingPromise = downloadOrgImgList($scope.status.uploaderImgSelected, 'originUrl', 'picDesc');
        };
        $scope.declareAll = function (index) {
            modalDialog.confirmModal('同步', '确定同步该说明到其它图片？', function () {
                $scope.data.DOC_PICTURELIST.forEach(function (data, key) {
                    $scope.data.DOC_PICTURELIST[key].picDesc = $scope.data.DOC_PICTURELIST[index].picDesc;
                })
            });
        }
        $scope.editImage = function (uploaderImg,index) {
            // 选择本地图片
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/png, image/jpeg, image/jpg, image/gif';
            input.click();
            input.onchange = function () {
                const file = input.files[0];
                var fd = new FormData();
                fd.append("file", file);
                var xhr = new XMLHttpRequest();
                xhr.open('POST', '/mcnww/upload/image.do', true);
                xhr.onerror = function (evt) {
                    modalDialog.alertType("错误提示", "上传失败，请重新上传", "warning", false, function() {});
                };
                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        var data = JSON.parse(xhr.responseText);
                        if (data.success) {
                            $scope.$apply(function() {
                                $scope.data.DOC_PICTURELIST[index].originUrl = data.url;
                                $scope.data.DOC_PICTURELIST[index].fileName = data.fileName;
                            });
                        } else {
                            modalDialog.alertType("错误提示", data.message, "error", false, function() {});
                        }
                    }
                 };
                xhr.send(fd);
            };
        }
        $scope.photoCrop = function (uploaderImg,index) {
            editPictureService.newCropper(uploaderImg.originUrl).then(function(data) {
                uploaderImg.originUrl = data.imgSrc;
                uploaderImg.fileName = data.imgName;
            });
        }
    }]);